var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit-menu"},[_c('div',{staticClass:"toggle"},[_c('button',{staticClass:"btn",class:{ disabled: !_vm.isActive },attrs:{"title":_vm.buttonTitle},on:{"click":_vm.toggleIsOpen}},[_c('fa',{attrs:{"icon":['fas', 'pen']}})],1)]),_c('div',{staticClass:"edit-menu__slot",class:{ open: _vm.isOpen }},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }